import type {
  AdminUgcApi,
  AdminUgcBrowseParams,
  AdminUgcBrowseResponse,
  AdminUgcListReportsParams,
  AdminUgcListReportsResponse,
  AdminUgcResolveAction,
} from './AppApi'
import { authedFetch } from './httpUtils'

export class HttpAdminUgcApi implements AdminUgcApi {
  private readonly appId: string

  constructor(appId: string) {
    this.appId = appId
  }

  async browse(
    params?: AdminUgcBrowseParams,
  ): Promise<AdminUgcBrowseResponse> {
    const response = await authedFetch(
      `/v1/ugc/${this.appId}/admin/browse`,
      { method: 'POST', body: JSON.stringify(params ?? {}) },
    )
    return (await response.json()) as AdminUgcBrowseResponse
  }

  async removeEntry(entryId: string): Promise<void> {
    await authedFetch(
      `/v1/ugc/${this.appId}/admin/entries/${entryId}/remove`,
      { method: 'POST' },
    )
  }

  async listReports(
    params?: AdminUgcListReportsParams,
  ): Promise<AdminUgcListReportsResponse> {
    const queryParams = new URLSearchParams()
    if (params?.status) queryParams.set('status', params.status)
    if (params?.cursor) queryParams.set('cursor', params.cursor)
    if (params?.limit) queryParams.set('limit', String(params.limit))
    const qs = queryParams.toString()
    const path = `/v1/ugc/${this.appId}/admin/reports${qs ? `?${qs}` : ''}`
    const response = await authedFetch(path, { method: 'GET' })
    return (await response.json()) as AdminUgcListReportsResponse
  }

  async resolveReport(
    reportId: string,
    action: AdminUgcResolveAction,
  ): Promise<void> {
    await authedFetch(
      `/v1/ugc/${this.appId}/admin/reports/${reportId}/resolve`,
      { method: 'POST', body: JSON.stringify({ action }) },
    )
  }
}
